// Feature toggles used to hide unfinished or internal dashboards from clients.
export const IS_CAPTAIN_UI_ENABLED = false;
export const IS_INBOX_UI_ENABLED = false;
export const IS_CAMPAIGNS_UI_ENABLED = false;
export const IS_REPORT_INBOX_ENABLED = false;
export const IS_REPORT_CSAT_ENABLED = false;
export const IS_REPORT_SLA_ENABLED = false;
export const IS_SETTINGS_INTEGRATIONS_ENABLED = false;
export const IS_SETTINGS_AUDIT_LOGS_ENABLED = false;
export const IS_SETTINGS_SLA_ENABLED = false;
export const IS_SETTINGS_CUSTOM_ROLES_ENABLED = false;
export const IS_SETTINGS_SECURITY_ENABLED = false;
export const IS_SETTINGS_AGENT_BOTS_ENABLED = false;
export const IS_AI_ASSIST_ENABLED = false;
export const IS_ACCOUNT_NAME_FIELD_ENABLED = false;
export const IS_ACCOUNT_ID_SECTION_ENABLED = false;
export const IS_BUILD_INFO_VISIBLE = false;
export const ARE_PROFILE_SHORTCUTS_VISIBLE = false;
export const ARE_PROFILE_DOCS_VISIBLE = false;
export const ARE_PROFILE_CHANGELOG_VISIBLE = false;
export const ARE_PROFILE_SUPERADMIN_VISIBLE = false;
